import AgendamentoInterceptor from '@finx/web-repository/src/apis/Agendamento/AgendamentoInterceptor'
// import LegacyInterceptor from '@finx/web-repository/src/apis/Legacy/LegacyInterceptor'
import FactoryResponse from '@/factories/FactoryResponse'
import { SolicitacaoComentario } from '@/types/_'

const factory = new FactoryResponse()
const api = new AgendamentoInterceptor()
// const api = new LegacyInterceptor()

export default {

  async enviarComentario(solicitacaoId: string, comentario: SolicitacaoComentario) {
    const request = await api.post(`solicitacoes/${solicitacaoId}/comentarios`, comentario)
    return factory.build(request)
  },


  async getComentariosBySolicitacaoId(solicitacaoId: string, tipo: string = 'comentario') {
    const request = await api.get(`solicitacoes/${solicitacaoId}/comentarios/${tipo}`)
    return factory.build(request)
  },


  async defineLembrete(params: any) {
    const request = await api.put(`solicitacoes/${params.solicitacaoId}/comentarios`, params)
    return factory.build(request)
  },

  async concluirLembrete(solicitacaoId: string) {
    const request = await api.put(`solicitacoes/${solicitacaoId}/comentarios/concluir-lembrete`, solicitacaoId)
    return factory.build(request)
  },
}
